/* ============================================================
   Blur Menu — behaviour (cached asset)
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_MAX = 990;

  function isMobile() {
    return window.innerWidth < MOBILE_MAX;
  }

  function isOpen() {
    return document.body.classList.contains('blur-menu-open');
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* ------------------------------------------------------------
     Live instances + document-level listeners.

     These listeners used to be registered inside init(), once per
     initialised section. That looked safe because init() is guarded by
     section.dataset.bmReady — but the Theme Editor replaces the section
     with a BRAND NEW DOM node on every setting change, so the guard never
     matched and each re-render added another keydown handler, another
     resize handler and another nested shopify:section:load handler, none
     of which were ever removed. A customising session accumulated them
     linearly: Escape eventually fired N times per press.

     They now live at module scope, registered exactly once, and dispatch
     to whichever instance is currently mounted. Same teardown pattern as
     assets/mobile-toolbar.js, which already got this right.
     ------------------------------------------------------------ */
  var instances = [];
  var globalBound = false;

  function currentInstance() {
    for (var i = 0; i < instances.length; i++) {
      if (document.body.contains(instances[i].overlay)) return instances[i];
    }
    return null;
  }

  function onGlobalKeydown(e) {
    if (!isOpen()) return;
    var inst = currentInstance();
    if (!inst) return;
    if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) {
      inst.overlay.setAttribute('data-bm-focus-mode', 'keyboard');
    }
    if (e.key === 'Escape') {
      inst.close();
      return;
    }
    inst.trapFocus(e);
  }

  function onGlobalHeaderClick(e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('.section-header') || target.closest('[data-blur-menu-trigger]')) return;
    if (!target.closest('a[href], button, summary, [role="button"]')) return;
    var inst = currentInstance();
    if (inst) inst.close({ restoreFocus: false, immediate: true });
  }

  function onGlobalResize() {
    if (isMobile()) {
      var inst = currentInstance();
      if (inst && isOpen()) inst.updatePosition();
      return;
    }
    for (var i = 0; i < instances.length; i++) instances[i].close();
  }

  function bindGlobal() {
    if (globalBound) return;
    globalBound = true;
    document.addEventListener('keydown', onGlobalKeydown);
    document.addEventListener('click', onGlobalHeaderClick, true);
    window.addEventListener('resize', onGlobalResize, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onGlobalResize, { passive: true });
  }

  /* Drop instances whose section has left the DOM, and take their portaled
     overlay with them. Without this the overlay - which init() moves into
     <body> so position:fixed resolves against the viewport - outlives every
     Theme Editor re-render. */
  function cleanupDetached() {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!document.contains(instances[i].section)) {
        try {
          instances[i].dispose();
        } catch (err) {
          /* one broken teardown must not strand the rest */
        }
        instances.splice(i, 1);
      }
    }
  }

  function init(section) {
    if (!section || section.dataset.bmReady === 'true') return;

    var overlay = section.querySelector('[data-blur-menu-overlay]');
    var panel = section.querySelector('[data-blur-menu-panel]');
    if (!overlay || !panel) return;

    section.dataset.bmReady = 'true';

    /* ------------------------------------------------------------
       بورتال: الـ overlay بينتقل يبقى آخر عنصر جوه <body>.
       ده بيضمن إن الـ position: fixed بتاعه يفضل نسبي للـ viewport
       دايمًا — حتى لو هيدر الثيم (أو أي عنصر أب تاني) عنده
       transform/filter/perspective/will-change، اللي بيعمل
       containing block جديد لأي عنصر fixed جواه. ده بالظبط سبب إن
       البانل كان بيغطي جزء من الصفحة بس، وإن سكرول الصفحة كان
       شغال من تحته وهو مفتوح.
       الفارياِبلز والستايلز المتعلّقة بالـ overlay/panel معرّفة في
       اللِكويد على [data-bm-id]، مش هي وراثة من الـ section، عشان
       تفضل شغالة صح بعد النقل.
       ------------------------------------------------------------ */
    overlay.setAttribute('data-bm-focus-mode', 'pointer');
    var bmId = overlay.getAttribute('data-bm-id') || section.id;
    if (bmId) {
      var stale = document.body.querySelectorAll(
        '.blur-menu-overlay[data-bm-id="' + bmId + '"]'
      );
      for (var s = 0; s < stale.length; s++) {
        if (stale[s] !== overlay && stale[s].parentNode === document.body) {
          stale[s].parentNode.removeChild(stale[s]);
        }
      }
    }
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    var scroller = overlay.querySelector('[data-blur-menu-scroll]') || panel;
    var closeBtn = overlay.querySelector('[data-blur-menu-close]');
    var rootScreen = overlay.querySelector('[data-blur-menu-screen="root"]');
    var headerBack = overlay.querySelector('[data-blur-menu-back]');
    var labelText = overlay.querySelector('[data-blur-menu-label-text]');
    var labels = {
      menu: section.dataset.labelMenu || 'Menu',
      back: section.dataset.labelBack || 'Back'
    };
    var speedOut = parseInt(section.dataset.speedOut, 10) || 300;
    var headerDrawer = section.dataset.headerDrawer === 'true';
    if (headerDrawer) panel.setAttribute('aria-modal', 'false');
    var screenAnimations = [];
    var isolatedNodes = [];
    var headerObserver = null;
    var opening = false;
    var savedBodyStyles = {};
    var scrollLocked = false;
    var pinnedHeader = null;
    var pinnedHeaderStyles = [];
    var headerPlaceholder = null;
    var currentScreen = 'root';
    var timer = null;
    var pressedOutside = false;
    var savedScrollY = 0;
    var lastFocused = null;

    /* ------------------------------------------------------------
       قفل السكرول: overflow:hidden على الـ body لوحده مش كافي —
       على سفاري iOS بالذات بيسيب المستخدم يسحب/يسكرول الصفحة اللي
       ورا البانل. فبنثبّت الـ body نفسه بـ position:fixed ونعوّض
       بإزاحة top بمكان السكرول الحالي، وبنرجّعه بالظبط لما نقفل.
       ------------------------------------------------------------ */

    function updatePosition() {
      if (!headerDrawer) return;
      var header = document.querySelector('.section-header .header');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      overlay.style.setProperty('--bm-header-bottom', Math.max(0, bottom) + 'px');
    }

    function isolateBackground() {
      if (isolatedNodes.length) return;
      var node = headerDrawer ? document.querySelector('.section-header') || trigger() : overlay;
      while (node && node !== document.body) {
        var parent = node.parentElement;
        if (!parent) break;
        [].forEach.call(parent.children, function (sibling) {
          if (sibling === node || sibling === overlay || sibling.contains(overlay) || sibling.inert) return;
          if (/^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
          isolatedNodes.push(sibling);
          sibling.inert = true;
        });
        node = parent;
      }
    }

    function restoreBackground() {
      isolatedNodes.forEach(function (node) { node.inert = false; });
      isolatedNodes = [];
    }

    function cancelScreenAnimations() {
      screenAnimations.forEach(function (animation) { animation.cancel(); });
      screenAnimations = [];
    }

    function slideScreen(target, id) {
      cancelScreenAnimations();
      var previous = overlay.querySelector('[data-blur-menu-screen="' + currentScreen + '"]');
      var forward = id !== 'root';
      var direction = overlay.dir === 'rtl' ? -1 : 1;
      var screens = overlay.querySelectorAll('.blur-menu-screen');
      [].forEach.call(screens, function (screen) {
        if (screen !== target && screen !== previous) {
          screen.hidden = true;
          screen.classList.remove('is-active');
        }
        screen.inert = screen !== target;
        screen.setAttribute('aria-hidden', screen === target ? 'false' : 'true');
      });
      if (previous) previous.style.zIndex = '1';
      target.style.zIndex = '2';
      target.hidden = false;
      target.scrollTop = 0;
      target.classList.add('is-active');
      currentScreen = id;
      overlay.dataset.menuLevel = id === 'root' ? 'root' : 'child';
      setHeader(id);
      if (headerBack && id !== 'root') headerBack.focus({ preventScroll: true });
      else {
        var first = target.querySelector('a[href], button');
        if (first) first.focus({ preventScroll: true });
      }
      var duration = prefersReducedMotion() ? 0 : 320;
      if (!target.animate || !duration) {
        if (previous) { previous.hidden = true; previous.classList.remove('is-active'); }
        return;
      }
      var options = { duration: duration, easing: 'cubic-bezier(0.16,1,0.3,1)', fill: 'both' };
      var entering = target.animate([
        { transform: 'translateX(' + (direction * (forward ? 100 : -100)) + '%)' },
        { transform: 'translateX(0)' }
      ], options);
      screenAnimations.push(entering);
      if (previous) {
        var leaving = previous.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(' + (direction * (forward ? -100 : 100)) + '%)' }
        ], options);
        screenAnimations.push(leaving);
        leaving.finished.then(function () {
          if (previous.dataset.blurMenuScreen !== currentScreen) {
            previous.hidden = true;
            previous.classList.remove('is-active');
          }
        }).catch(function () {});
      }
      entering.finished.catch(function () {});
    }

    /* Keep the header in viewport coordinates before fixing the body.
       Body scroll locking resets window.scrollY, so position:sticky alone
       cannot keep the header visible on a scrolled product page. */
    function pinHeader() {
      if (!headerDrawer || pinnedHeader) return;
      var header = document.querySelector('.section-header');
      if (!header) return;
      var bounds = header.getBoundingClientRect();
      var computed = window.getComputedStyle(header);
      pinnedHeader = header;
      pinnedHeaderStyles = ['position', 'top', 'left', 'right', 'width', 'z-index', 'transition', 'margin-top', 'margin-bottom'].map(function (property) {
        return { property: property, value: header.style.getPropertyValue(property), priority: header.style.getPropertyPriority(property) };
      });
      if (bounds.height > 0) {
        headerPlaceholder = document.createElement('div');
        headerPlaceholder.setAttribute('aria-hidden', 'true');
        headerPlaceholder.style.cssText = 'display:block;visibility:hidden;pointer-events:none;';
        headerPlaceholder.style.height = bounds.height + 'px';
        headerPlaceholder.style.marginTop = computed.marginTop;
        headerPlaceholder.style.marginBottom = computed.marginBottom;
        header.insertAdjacentElement('afterend', headerPlaceholder);
      }
      header.setAttribute('data-blur-menu-header-locked', '');
      header.style.setProperty('position', 'fixed');
      header.style.setProperty('top', Math.max(0, bounds.top) + 'px');
      header.style.setProperty('left', '0');
      header.style.setProperty('right', '0');
      header.style.setProperty('width', '100%');
      header.style.setProperty('z-index', '1000000');
      header.style.setProperty('transition', 'none');
      header.style.setProperty('margin-top', '0');
      header.style.setProperty('margin-bottom', '0');
    }

    function unpinHeader() {
      if (!pinnedHeader) return;
      var sticky = pinnedHeader.querySelector('sticky-header');
      if (sticky) sticky.currentScrollTop = window.scrollY || window.pageYOffset || 0;
      pinnedHeaderStyles.forEach(function (saved) {
        if (saved.value) pinnedHeader.style.setProperty(saved.property, saved.value, saved.priority);
        else pinnedHeader.style.removeProperty(saved.property);
      });
      pinnedHeader.removeAttribute('data-blur-menu-header-locked');
      if (headerPlaceholder) headerPlaceholder.remove();
      headerPlaceholder = null;
      pinnedHeaderStyles = [];
      pinnedHeader = null;
    }

    function lockScroll() {
      if (scrollLocked) return;
      scrollLocked = true;
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      ['position', 'top', 'left', 'right', 'width'].forEach(function (key) { savedBodyStyles[key] = document.body.style[key]; });
      document.body.style.position = 'fixed';
      document.body.style.top = -savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      if (!scrollLocked) { unpinHeader(); return; }
      scrollLocked = false;
      ['position', 'top', 'left', 'right', 'width'].forEach(function (key) { document.body.style[key] = savedBodyStyles[key] || ''; });
      window.scrollTo({ top: savedScrollY, behavior: 'instant' });
      unpinHeader();
    }

    /* ------------------------------------------------------------
       إظهار العناصر: اللي ظاهر في البانل بياخد stagger عادي،
       واللي تحت بيستنى لحد ما يوصل للشاشة (IntersectionObserver)
       ------------------------------------------------------------ */
    var observer = null;

    function clearReveal() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      var items = overlay.querySelectorAll('.bm-reveal');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-in', 'is-late');
        items[i].style.removeProperty('--bm-i');
      }
    }

    function revealScreen(screen) {
      if (headerDrawer) return;
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      var items = [].slice.call(screen.querySelectorAll('.bm-reveal'));
      if (!items.length) return;

      var scrollBounds = scroller.getBoundingClientRect();
      var visible = [];
      var later = [];

      for (var i = 0; i < items.length; i++) {
        var itemBounds = items[i].getBoundingClientRect();
        if (itemBounds.top < scrollBounds.bottom && itemBounds.bottom > scrollBounds.top) visible.push(items[i]);
        else later.push(items[i]);
      }

      for (var v = 0; v < visible.length; v++) {
        visible[v].style.setProperty('--bm-i', v);
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          for (var v = 0; v < visible.length; v++) visible[v].classList.add('is-in');
        });
      });

      if (!later.length || !('IntersectionObserver' in window)) {
        for (var l = 0; l < later.length; l++) {
          later[l].style.setProperty('--bm-i', 0);
          later[l].classList.add('is-late', 'is-in');
        }
        return;
      }

      var batch = 0;
      var batchTime = 0;

      observer = new IntersectionObserver(
        function (entries) {
          var now = Date.now();
          if (now - batchTime > 260) batch = 0;
          batchTime = now;

          for (var e = 0; e < entries.length; e++) {
            if (!entries[e].isIntersecting) continue;
            var el = entries[e].target;
            el.style.setProperty('--bm-i', batch++);
            el.classList.add('is-late', 'is-in');
            observer.unobserve(el);
          }
        },
        { root: scroller, threshold: 0.15 }
      );

      for (var j = 0; j < later.length; j++) observer.observe(later[j]);
    }

    function trigger() {
      return document.querySelector('[data-blur-menu-trigger]');
    }

    /* ---------- focus trap بسيط جوه البانل وهو مفتوح ---------- */
    function focusableItems() {
      var nodes = overlay.querySelectorAll(
        'a[href], button:not([disabled]), summary, select:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var list = [].slice.call(nodes).filter(function (el) {
        return el.offsetParent !== null && !el.closest('[inert]');
      });
      var header = headerDrawer && document.querySelector('.section-header');
      if (header) {
        var headerNodes = header.querySelectorAll(
          'a[href], button:not([disabled]), summary, select:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        var headerItems = [].slice.call(headerNodes).filter(function (el) {
          return el.offsetParent !== null && !el.closest('[inert]');
        });
        list = headerItems.concat(list);
      }
      return list;
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var items = focusableItems();
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (!isMobile() || isOpen() || opening) return;
      opening = true;
      updatePosition();

      window.clearTimeout(timer);
      reset();
      lastFocused = document.activeElement;
      pinHeader();
      lockScroll();
      isolateBackground();
      if (headerDrawer && window.ResizeObserver) {
        var header = document.querySelector('.section-header .header');
        if (header) { headerObserver = new ResizeObserver(updatePosition); headerObserver.observe(header); }
      }

      overlay.removeAttribute('hidden');
      overlay.setAttribute('aria-hidden', 'false');
      if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');

      var btn = trigger();
      if (btn) btn.setAttribute('aria-expanded', 'true');

      scroller.scrollTop = 0;

      /* double rAF عشان الترانزشن يشتغل بعد ما العنصر يترسم */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!opening || !section.isConnected) return;
          document.body.classList.add('blur-menu-open');
          updatePosition();
          if (rootScreen) revealScreen(rootScreen);
          if (headerDrawer) {
            var first = rootScreen && rootScreen.querySelector('a[href], button');
            if (first) first.focus({ preventScroll: true });
            else panel.focus();
          } else if (closeBtn) closeBtn.focus();
          else panel.focus();
        });
      });
    }

    function close(options) {
      options = options || {};
      if (!isOpen() && !opening) return;
      opening = false;
      if (headerObserver) { headerObserver.disconnect(); headerObserver = null; }
      cancelScreenAnimations();
      restoreBackground();

      document.body.classList.remove('blur-menu-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (closeBtn) closeBtn.setAttribute('aria-expanded', 'false');

      var btn = trigger();
      if (btn) btn.setAttribute('aria-expanded', 'false');

      unlockScroll();

      if (options.restoreFocus !== false) {
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        } else if (btn) {
          btn.focus({ preventScroll: true });
        }
      }
      lastFocused = null;

      window.clearTimeout(timer);
      var finishClose = function () {
        if (!isOpen()) {
          overlay.setAttribute('hidden', '');
          clearReveal();
          reset();
        }
      };
      if (options.immediate) {
        finishClose();
      } else {
        var delay = prefersReducedMotion() ? 0 : speedOut + 60;
        timer = window.setTimeout(finishClose, delay);
      }
    }

    function toggle(sourceEvent) {
      if (sourceEvent && typeof sourceEvent.detail === 'number') {
        overlay.setAttribute('data-bm-focus-mode', sourceEvent.detail === 0 ? 'keyboard' : 'pointer');
      }
      if (isOpen() || opening) close();
      else open();
    }

    /* ---------- شاشات ---------- */
    function setHeader(id) {
      [].forEach.call(overlay.querySelectorAll('[data-blur-menu-open]'), function (opener) {
        var key = opener.getAttribute('data-blur-menu-open');
        var screen = overlay.querySelector('[data-blur-menu-screen="' + key + '"]');
        if (screen && !screen.id) screen.id = overlay.id + '-' + key;
        if (screen) opener.setAttribute('aria-controls', screen.id);
        opener.setAttribute('aria-expanded', String(key === id));
      });
      if (!headerBack) return;
      headerBack.classList.toggle('is-back', id !== 'root');
      var target = overlay.querySelector('[data-blur-menu-screen="' + id + '"] nav');
      if (labelText) labelText.textContent = id === 'root' ? labels.menu : headerDrawer && target ? target.getAttribute('aria-label') : labels.back;
    }

    function go(id) {
      var target =
        id === 'root'
          ? rootScreen
          : overlay.querySelector('.blur-menu-screen[data-blur-menu-screen="' + id + '"]');

      if (!target || id === currentScreen) return;
      if (headerDrawer) { slideScreen(target, id); return; }

      var screens = overlay.querySelectorAll('.blur-menu-screen');
      for (var i = 0; i < screens.length; i++) {
        screens[i].inert = screens[i] !== target;
        screens[i].setAttribute('aria-hidden', screens[i] === target ? 'false' : 'true');
        if (screens[i] !== target) {
          screens[i].classList.remove('is-active');
          screens[i].setAttribute('hidden', '');
        }
      }

      target.removeAttribute('hidden');
      target.classList.remove('is-active');
      scroller.scrollTop = 0;

      var previous = overlay.querySelectorAll('.bm-reveal.is-in');
      for (var p = 0; p < previous.length; p++) {
        previous[p].classList.remove('is-in', 'is-late');
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.classList.add('is-active');
          revealScreen(target);
          if (headerBack && id !== 'root') headerBack.focus({ preventScroll: true });
          else {
            var first = target.querySelector('a[href], button');
            if (first) first.focus({ preventScroll: true });
          }
        });
      });

      currentScreen = id;
      overlay.dataset.menuLevel = id;
      setHeader(id);
    }

    function reset() {
      [].forEach.call(overlay.querySelectorAll('details.bm-side-accordion[open]'), function (details) {
        details.removeAttribute('open');
      });
      cancelScreenAnimations();
      overlay.dataset.menuLevel = 'root';
      var screens = overlay.querySelectorAll('.blur-menu-screen');
      for (var i = 0; i < screens.length; i++) {
        var isRoot = screens[i] === rootScreen;
        screens[i].classList.toggle('is-active', isRoot);
        screens[i].inert = !isRoot;
        screens[i].setAttribute('aria-hidden', isRoot ? 'false' : 'true');
        if (isRoot) screens[i].removeAttribute('hidden');
        else screens[i].setAttribute('hidden', '');
      }
      currentScreen = 'root';
      setHeader('root');
    }

    /* ---------- أحداث ---------- */
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Native language picker uses Shopify's localization form. Keeping this
       independent avoids importing another drawer or a localization library.
       Native selection is particularly reliable on iOS and cannot be clipped
       behind the sticky footer. Never close the menu on a picker click. */
    var languageSelect = overlay.querySelector('[data-blur-menu-language]');
    if (languageSelect && languageSelect.form) {
      var originalLanguage = languageSelect.value;
      languageSelect.addEventListener('change', function () {
        var form = languageSelect.form;
        if (!form || !languageSelect.value || languageSelect.value === originalLanguage ||
            form.dataset.bmSubmitting === 'true') return;
        form.dataset.bmSubmitting = 'true';
        form.setAttribute('aria-busy', 'true');
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else HTMLFormElement.prototype.submit.call(form);
        } catch (err) {
          delete form.dataset.bmSubmitting;
          form.removeAttribute('aria-busy');
        }
      });
    }

    /* قفل بالدوس في أي مكان بره البانل.
       بنتأكد إن الدوسة بدأت وخلصت بره، عشان السحب من جوه ميقفلش. */
    overlay.addEventListener('pointerdown', function (e) {
      overlay.setAttribute('data-bm-focus-mode', 'pointer');
      pressedOutside = !panel.contains(e.target);
    });

    overlay.addEventListener('pointerup', function (e) {
      if (pressedOutside && !panel.contains(e.target)) close();
      pressedOutside = false;
    });

    /* keydown is handled at module scope (onGlobalKeydown) and routed back
       to this instance via the registry at the end of init(). */

    /* ملحوظة: الحدث ده كان متعلّق على section، لكن دلوقتي إن الـ
       overlay بينتقل يبقى جوه <body>، لازم يتعلّق على الـ overlay
       نفسه عشان يفضل بيسمع كل الكليكات اللي جواه (delegation
       بيعتمد على إن العنصر يكون أب فعلي في الـ DOM). */
    overlay.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-blur-menu-open]');
      if (opener) {
        e.preventDefault();
        go(opener.getAttribute('data-blur-menu-open'));
        return;
      }

      if (headerBack && e.target.closest('[data-blur-menu-back]')) {
        if (currentScreen !== 'root') go('root');
        return;
      }

      if (e.target.closest('a')) close();
    });

    /* resize is handled at module scope (onGlobalResize). */

    /* ---------- ربط أيقونة الهيدر ---------- */
    function bind() {
      var btn = trigger();
      if (!btn) return;
      if (overlay.id) btn.setAttribute('aria-controls', overlay.id);
      btn.setAttribute('aria-haspopup', 'dialog');
      if (btn.dataset.blurMenuBound === 'true') return;
      btn.dataset.blurMenuBound = 'true';

      btn.addEventListener(
        'click',
        function (e) {
          if (!isMobile()) return;
          e.preventDefault();
          e.stopPropagation();
          var active = currentInstance();
          if (active) active.toggle(e);
        },
        true
      );
    }

    setHeader('root');
    bind();

    /* Register with the module-scope dispatcher. `bind` is exposed so that a
       header re-render (which replaces the trigger button) can be re-bound
       from initAll rather than from a nested section:load listener. */
    instances.push({
      section: section,
      overlay: overlay,
      close: close,
      toggle: toggle,
      trapFocus: trapFocus,
      updatePosition: updatePosition,
      bind: bind,
      dispose: function () {
        opening = false;
        restoreBackground();
        cancelScreenAnimations();
        if (headerObserver) headerObserver.disconnect();
        window.clearTimeout(timer);
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        if (overlay && overlay.parentNode === document.body) {
          document.body.removeChild(overlay);
        }
        /* If this instance was mid-open when its section was removed, the
           scroll lock would otherwise stay applied to <body> forever. */
        if (isOpen() || scrollLocked) {
          document.body.classList.remove('blur-menu-open');
          unlockScroll();
        }
        unpinHeader();
      }
    });

    bindGlobal();
  }

  function initAll() {
    cleanupDetached();
    var sections = document.querySelectorAll('[data-blur-menu-section]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
    /* The header is a separate section; when IT re-renders the trigger button
       is replaced and needs re-binding even though no blur-menu section
       changed. Cheap and idempotent - bind() no-ops on an already-bound
       button. */
    for (var j = 0; j < instances.length; j++) instances[j].bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', cleanupDetached);
})();